import {Box3, Object3D, Vector3} from "three";
import {MTLLoader} from "three/examples/jsm/loaders/MTLLoader";
import * as Globals from "../../globals";
import {setActiveMode} from "../../globals";
import * as SceneManager from "../../sceneManager";
import {clearGroup, render} from "../../sceneManager";
import {TransactionManager} from "../../TransactionManager";
import {clearStates, furnitureGroup, isDeleteMode, mousePosition, toggleModeButtons} from "../../main";
import {cleanUpColladaModel, colladaLoader, loadModel, objLoader} from "../../utils/modelLoader";
import {getHighestParentGroup, setMaterial} from "../../utils/threeUtils";
import {setObjectLayer} from "../../utils/layerUtils";
import {getWallGroups} from "../../utils/configuratorUtils";
import {degToRad} from "../../utils/mathUtils";
import {plainFurnitureMaterial} from "../../constants/materialConstants";

let currentWalls = [];
const placeableObjectOptions = $('#furniture-dialog');
let currentObject, currentObjectPosition;
let currentObjectAdded = false;
let objectPlaceable = true;

//TODO: Model laden sollte über die modelloader.js erfolgen
export async function loadSelectedFurniture(addTo, materialUrl, objectUrl, objectName, scaleFactor, yOffset = 0) {
    if (objectUrl.includes(".dae")) {
        let tmp = await loadModel(colladaLoader, objectUrl);
        currentObject = new Object3D();
        currentObject.add(tmp.scene);
        currentObject.name = objectName;
        currentObjectPosition = undefined;
        currentObjectAdded = false;
        cleanUpColladaModel(currentObject);
        currentObject.scale.set(scaleFactor, scaleFactor, scaleFactor);
        currentObject.userData.yOffset = yOffset;
        setMaterial(currentObject, plainFurnitureMaterial, true);

    } else {
        if (materialUrl !== "") {
            const mtlLoader = new MTLLoader();
            mtlLoader.load(materialUrl, (mtl) => {
                mtl.preload();
                objLoader.setMaterials(mtl);
                loadObjFile(addTo, objectUrl, objectName, scaleFactor);
            });
        } else {
            loadObjFile(addTo, objectUrl, objectName, scaleFactor);
        }
    }

    return currentObject;
}

function loadObjFile(addTo, objectUrl, objectName, scaleFactor) {
    objLoader.load(objectUrl, (objGroup) => {
        objGroup.scale.set(scaleFactor, scaleFactor, scaleFactor);
        objGroup.name = objectName;
        // objGroup.receiveShadow = true;
        // objGroup.castShadow = true;

        currentObject = objGroup;
        currentObjectPosition = undefined;
        currentObjectAdded = false;
    });
}

// bewegt ausgewähltes Objekt in der Szene
export function generateFurniturePreview() {
    if (currentObject === undefined) {
        return;
    }

    try {
        currentObjectPosition = mousePosition;
        //Calculate object position based on bounding box center
        let center = new Box3().setFromObject(currentObject).getCenter(new Vector3());
        let diffVector = new Vector3().copy(currentObject.position).sub(center);
        currentObject.position.set(mousePosition.x + diffVector.x, currentObject.position.y, mousePosition.z + diffVector.z);

        if (!currentObjectAdded) {
            currentWalls = getWallGroups();
            furnitureGroup.addWithUuid(currentObject);
            let bounds = new Box3().setFromObject(currentObject);
            let yDiff = 0 - bounds.min.y;
            //TODO: yOffset in DB definierbar. Muss später im Konfigurator selbst einstellbar sein per Gizmo
            let yOffset = currentObject.userData.yOffset !== undefined ? currentObject.userData.yOffset : 0;
            currentObject.position.setY(currentObject.position.y + yDiff + yOffset);
            setObjectLayer(furnitureGroup, Globals.layers.furniture, true);
            currentObjectAdded = true;
        }

        let intersectsWalls = checkForIntersectionWithWalls();
        let intersectsFurniture = checkForIntersectionWithFurniture();

        if (!intersectsFurniture && !intersectsWalls) {
            objectPlaceable = true;
        }

        if (objectPlaceable) {
            currentObjectPosition = currentObject.position;
        }
    } catch (e) {
        console.error(e);
        clearStates();
    }
}

function checkForIntersectionWithWalls() {
    let currentObjectBBox = new Box3().setFromObject(currentObject); // bounding box des ausgewählten Objektes berechnen
    for (let i = 0; i < currentWalls.length; i++) {
        let otherObjectsBBox = new Box3().setFromObject(currentWalls[i]); // bounding box des anderen Raumobjektes berechnen hier: nicht den gesamten Raum nehmen, sondern nur die Wände und Boden und Dach

        if (otherObjectsBBox.intersectsBox(currentObjectBBox)) {
            objectPlaceable = false;
            return true;
        }
    }

    return false;
}

function checkForIntersectionWithFurniture() {
    let currentObjectBBox = new Box3().setFromObject(currentObject);

    for (let i = 0; i < furnitureGroup.children.length; i++) {
        if (furnitureGroup.children[i] === currentObject) {
            continue;
        }

        let otherObjectsBBox = new Box3().setFromObject(furnitureGroup.children[i]);
        if (currentObjectBBox.intersectsBox(otherObjectsBBox)) {
            objectPlaceable = false;
            return true;
        }
    }

    return false;
}

$('#furniture-rotation-map').on('click', '.furniture-rotation-area', function () {
    let placeFurnitureBtn = document.getElementById('furniture-place-btn');
    let rotation = $(this).data('rotation');
    rotateFurniture(rotation);
    placeFurnitureBtn.disabled = !objectPlaceable;
    render();
});

export function rotateFurniture(rotation) {
    TransactionManager.startTransaction();
    let currentCenter = new Box3().setFromObject(currentObject).getCenter(new Vector3());
    currentObject.rotation.y = degToRad(parseInt(rotation));
    let rotatedCenter = new Box3().setFromObject(currentObject).getCenter(new Vector3());
    let diffVector = new Vector3().copy(rotatedCenter).sub(currentCenter);

    $('#furniture-rotation-image').attr('src', $('#furniture-rotation-image').data('src-rot-' + rotation));

    currentObject.position.set(currentObject.position.x - diffVector.x, currentObject.position.y, currentObject.position.z - diffVector.z);
    checkForIntersection(currentObject);
    if(objectPlaceable)
        TransactionManager.stopTransaction();
}

export function showFurnitureOptionsContainer(isDraggingObject) {
    if (!isDeleteMode && !isDraggingObject && currentObjectPosition !== undefined && currentObject !== undefined && currentObject !== null) {
        placeableObjectOptions.removeClass('d-none').show();
        repositionOptionsContainer();

        let placeFurnitureBtn = document.getElementById('furniture-place-btn');
        placeFurnitureBtn.disabled = !objectPlaceable;
        placeFurnitureBtn.onclick = function () {
            placeableObjectOptions.addClass('d-none');
            placeFurnitureAtCurrentPosition();
            TransactionManager.stopTransaction();
            toggleModeButtons();
            setActiveMode(Globals.modes.view);
        };

        let deleteFurnitureBtn = document.getElementById('furniture-delete-btn');
        deleteFurnitureBtn.onclick = function () {
            placeableObjectOptions.addClass('d-none');
            currentObject.removeFromParent();
            currentObjectPosition = undefined;
            objectPlaceable = false;
            TransactionManager.stopTransaction();
            toggleModeButtons();
            setActiveMode(Globals.modes.view);
        };
    }
}

export function deleteFurniture(object) {
    clearGroup(object);
    object.removeFromParent();
}

export function hideFurnitureOptionsContainer() {
    placeableObjectOptions.addClass('d-none');
}

export function activateFurnitureObject(isDragging) {
    if (isDeleteMode) {
        setActiveMode(Globals.modes.view);
        return;
    }
    currentWalls = getWallGroups();

    let intersect = SceneManager.raycaster.intersectObjects(furnitureGroup.children, true);
    if (intersect.length > 0) {
        clearStates();
        currentObject = getHighestParentGroup(furnitureGroup, intersect[0].object);
        currentObjectPosition = currentObject.position;
        if (isDragging) {
            hideFurnitureOptionsContainer();
        } else {
            let intersectsWalls = checkForIntersectionWithWalls();
            let intersectsFurniture = checkForIntersectionWithFurniture();
            objectPlaceable = (!intersectsFurniture && !intersectsWalls);
            showFurnitureOptionsContainer(isDragging);
        }
        Globals.setActiveMode(Globals.modes.furniture);
    }
}

function placeFurnitureAtCurrentPosition() {
    if (objectPlaceable) {
        currentObject = undefined;
        currentObjectPosition = undefined;
        objectPlaceable = false;
    }
}

export function repositionOptionsContainer() {
    /*if (currentObject === undefined) {
        return;
    }

    let bounds = new Box3().setFromObject(currentObject)
    let vector = bounds.max
    let objectPosition = getScreenPositionFromVector(layoutView, layoutCamera, vector);
    console.log(objectPosition)
    let layoutViewBounds = layoutView.getBoundingClientRect();
    placeableObjectOptions.css('left', layoutViewBounds.left + objectPosition.x + "px");
    placeableObjectOptions.css('top', layoutViewBounds.top + objectPosition.y + "px");*/
}

function checkForIntersection(currentObject) {
    objectPlaceable = false;
    let intersectsWalls = checkForIntersectionWithWalls();
    let intersectsFurniture = checkForIntersectionWithFurniture();

    // prüfen, ob sich keine Objekte schneiden
    if (!intersectsWalls && !intersectsFurniture) {
        currentObjectPosition = currentObject.position;
        objectPlaceable = true;
    }
}
